import React from 'react'

import { CuratedAccommodationItemSelection } from './CuratedAccommodationItemSelection'

import { CuratedBaseItemSelection } from 'tripPlanner/components/CuratedItemSelection/CuratedBaseItemSelection'
import { CuratedExperienceItemSelection } from 'tripPlanner/components/CuratedItemSelection/CuratedExperienceItemSelection'
import { CuratedFlightItemSelection } from 'tripPlanner/components/CuratedItemSelection/CuratedFlightItemSelection'
import { CuratedProductImage } from 'tripPlanner/components/CuratedItemSelection/CuratedProductImage'
import { ItemMetadata } from 'tripPlanner/models'
import { TripItem } from 'tripPlanner/types/tripItem'
import { getDisplayableCustomThingToDoName } from 'tripPlanner/utils/itemConversions/common'

interface Props {
  item: TripItem
  onSelect: () => void
  isSelected: boolean
}

export default function CuratedItemSelection({
  item,
  onSelect,
  isSelected,
}: Props) {
  const getItem = () => {
    switch (item.type) {
      case 'FLIGHT':
        return (
          <CuratedFlightItemSelection
            item={item}
            onSelect={onSelect}
            isSelected={isSelected}
          />
        )
      case 'ACCOMMODATION':
        return (
          <CuratedAccommodationItemSelection
            item={item}
            onSelect={onSelect}
            isSelected={isSelected}
          />
        )
      case 'NOTE':
        return (
          <CuratedBaseItemSelection
            type={item.type}
            title={item.title}
            onSelect={onSelect}
            isSelected={isSelected}
            image={<CuratedProductImage item={item} />}
          />
        )
      case 'RESTAURANT_BAR':
        return (
          <CuratedBaseItemSelection
            title={item.place.name}
            type={item.type}
            onSelect={onSelect}
            isSelected={isSelected}
            image={
              <CuratedProductImage
                item={item}
                placeId={'id' in item.place ? item.place.id : undefined}
              />
            }
          />
        )
      case 'ATTRACTION':
        return (
          <CuratedBaseItemSelection
            title={item.place.name}
            type={item.type}
            onSelect={onSelect}
            isSelected={isSelected}
            image={
              <CuratedProductImage
                item={item}
                placeId={'id' in item.place ? item.place.id : undefined}
              />
            }
          />
        )
      case 'THING_TO_DO':
        return (
          <CuratedBaseItemSelection
            title={getDisplayableCustomThingToDoName(item)}
            type={item.type}
            onSelect={onSelect}
            isSelected={isSelected}
            image={
              <CuratedProductImage
                item={item}
                imgSrc={item.startPlace.photoUrl}
                placeId={
                  'id' in item.startPlace ? item.startPlace.id : undefined
                }
              />
            }
          />
        )
      case 'CAR_RENTAL':
        return (
          <CuratedBaseItemSelection
            title={item.companyName}
            type={item.type}
            onSelect={onSelect}
            isSelected={isSelected}
            image={
              <CuratedProductImage
                item={item}
                placeId={
                  'id' in item.startPlace ? item.startPlace.id : undefined
                }
              />
            }
          />
        )
      case 'CRUISE':
        return (
          <CuratedBaseItemSelection
            title={item.name}
            type={item.type}
            onSelect={onSelect}
            isSelected={isSelected}
            image={<CuratedProductImage item={item} />}
          />
        )
      case 'TOUR':
        return (
          <CuratedBaseItemSelection
            title={item.name}
            type={item.type}
            onSelect={onSelect}
            isSelected={isSelected}
            image={
              <CuratedProductImage
                item={item}
                placeId={
                  item.startPlace.type === 'GEO' ?
                    item.startPlace.id :
                    undefined
                }
              />
            }
          />
        )
      case 'EVENT':
        return (
          <CuratedBaseItemSelection
            title={getDisplayableCustomThingToDoName(item)}
            type={item.type}
            onSelect={onSelect}
            isSelected={isSelected}
            image={
              <CuratedProductImage
                item={item}
                imgSrc={
                  item.place.type == 'GEO' ? item.place.photoUrl : undefined
                }
                placeId={'id' in item.place ? item.place.id : undefined}
              />
            }
          />
        )
      case 'EXPERIENCE':
        return (
          <CuratedExperienceItemSelection
            item={item}
            isSelected={isSelected}
            onSelect={onSelect}
          />
        )
      case 'FERRY':
      case 'BUS':
      case 'TRAIN':
      case 'OTHER_TRANSPORT':
        return (
          <CuratedBaseItemSelection
            title={`${ItemMetadata[item.type].singularName} ${
              item.operatorName ? `• ${item.operatorName}` : ''
            }`}
            type={item.type}
            onSelect={onSelect}
            isSelected={isSelected}
          />
        )
    }
  }

  return getItem()
}
